<template>
  <div class="app-container">
    <FaqPanel
      page="referrals_dsp"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-tabs v-model="activeTab">
      <el-tab-pane
        label="Invite Advertisers"
        name="advertiser"
        class="ref-tab advertiser-tab"
      >
        <AdvertReferrals />
      </el-tab-pane>
      <el-tab-pane
        label="Invite Publishers"
        name="publisher"
        class="ref-tab publisher-tab"
      >
        <PublisherReferrals />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { useUserStore } from '@/store/modules/user'
import FaqPanel from '@/components/FaqPanel/Index.vue'
import AdvertReferrals from './components/AdvertReferrals.vue'
import PublisherReferrals from './components/PublisherReferrals.vue'

export default defineComponent({
  name: 'ReferralsIndex',
  components: {
    FaqPanel,
    AdvertReferrals,
    PublisherReferrals
  },
  setup(_props, context) {
    const userStore = useUserStore()
    const activeTab = ref('advertiser')
    const link = computed(
      () => `https://www.adspyglass.com/?u=${userStore.referrerCode}`
    )
    const icons = [
      'adcash.png',
      'adnium.png',
      'adskeeper.png',
      'adsterra.png',
      'adsupply.png',
      'adt.png',
      'adxxx.jpg',
      'af.jpeg',
      'bidpush.jpeg',
      'bigclick.png',
      'buy.jpg',
      'clickadu.png',
      'clickaine.png',
      'dao.jfif',
      'evadav.png',
      'exo.png',
      'explorads.png',
      'fpc.png',
      'gadsbee.png',
      'heartbid.jpeg',
      'hilltopads.png',
      'inxyads.png',
      'juicy.png',
      'kadam.png',
      'mbc.png',
      'mpay.png',
      'noviclick.jfif',
      'plio.png',
      'plugrush.png',
      'popcash.png',
      'popmyads.png',
      'propeller.png',
      'rivertraffic.png',
      'royalads.png',
      'runative.png',
      'trafficforce.png',
      'traffichunt.png',
      'trafficshop.png',
      'trafficstars.png',
      'trafichaus.png',
      'tubecorporate.png',
      'twinred.jpg',
      'zeropark.jfif'
    ]

    return { link, icons, activeTab }
  }
})
</script>
